import { useTranslation } from 'react-i18next';
import { CAPTION_LANGUAGES, type CaptionLanguage } from '@/core/captions/types';

/**
 * A speech language's name for use in a sentence, in the person's own
 * language ("Turkish" in English, "Türkçe" in Turkish), for codes outside our
 * list too. The language picker shows each language in its own name instead.
 */
export function useLanguageName() {
  const { t, i18n } = useTranslation();
  return (code: string): string => {
    try {
      const name = new Intl.DisplayNames([i18n.language], { type: 'language' }).of(code);
      if (name && name !== code) return name;
    } catch {
      // An engine without display names falls back to the picker's names.
    }
    return (CAPTION_LANGUAGES as readonly string[]).includes(code) ? t(`captions.languages.${code as CaptionLanguage}`) : code.toUpperCase();
  };
}
